import { styled } from "@mui/material/styles";

export const AccessActionButton = styled("button")(({ theme }) => ({
  background: "none",
  border: "none",
  padding: 0,
  margin: 0,
  cursor: "pointer",
  textTransform: "uppercase",
  fontSize: "12px",
  fontWeight: 700,
  letterSpacing: "0.02em",
  color: theme.palette.primary.main,
  textAlign: "left",
  "&:disabled": {
    color: theme.palette.action.disabled,
    cursor: "not-allowed",
  },
}));
